@if (showPrivacyPolicy) {
  <div class="em-c-modal em-c-modal--alert em-js-modal-only" id="">
    <div class="em-c-modal__window em-js-modal-window minimal-padding">
      <div class="em-c-modal__header">
        <h3 class="em-c-modal__title">Notice</h3>
      </div>
      <!-- end em-c-modal__header -->
      <div class="em-c-modal__body em-c-text-passage em-c-text-passage--small">
        This Entitlement portal collects personal information i.e. name and
        store it for internal purpose such as auditing and data analysis.
        <div class="em-c-btn-group em-c-modal--alert em-js-modal-only">
          <button
            class="em-c-btn em-c-btn--primary em-js-modal-confirm-trigger"
            (click)="agreeToPrivacyPolicy()"
          >
            <span class="em-c-btn__text">OK</span>
          </button>
          <!-- end em-c-btn -->
        </div>
        <!-- end em-c-btn-group -->
      </div>
      <!-- end em-c-modal__body -->
    </div>
    <!-- end em-c-modal__window -->
  </div>
}
